exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".share-with-container.is-empty .share-with-content[data-v-ec4fed90],.share-with-container .reserve-chip[data-v-ec4fed90]{visibility:hidden}.share-with-container.is-empty[data-v-ec4fed90]{background-color:transparent!important;box-shadow:none!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-ec4fed90","scoped":true,"sourceMap":false}!./~/postcss-loader/lib!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/account/ContactsInput.vue
// module id = 1055
// module chunks = 22